import { render, staticRenderFns } from "./indexRight01.vue?vue&type=template&id=649ef868&scoped=true&"
import script from "./indexRight01.vue?vue&type=script&lang=js&"
export * from "./indexRight01.vue?vue&type=script&lang=js&"
import style0 from "./indexRight01.vue?vue&type=style&index=0&id=649ef868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ef868",
  null
  
)

export default component.exports